import { Head, router, useForm, usePage } from "@inertiajs/react"

import { BusinessForm } from "@/components/businesses/business-form"
import AppLayout from "@/layouts/app-layout"
import { businessesCreatePath, marketplacePath } from "@/routes"

interface Neighborhood {
  id: number
  name: string
}

interface BusinessesNewProps {
  business: Record<string, unknown>
  neighborhoods: Neighborhood[]
}

export default function BusinessesNew({ neighborhoods }: BusinessesNewProps) {
  interface BusinessFormData {
    business_name: string
    business_type: "store" | "restaurant" | "service" | "delivery"
    description: string
    phone: string
    email: string
    website: string
    address: string
    latitude: string
    longitude: string
    neighborhood_id: string
    opening_hours: string
    delivery_coverage: string
    images: File[]
    image_urls: string[]
  }

  const page = usePage()
  const search = page.url.includes("?") ? page.url.split("?")[1] : ""
  const params = new URLSearchParams(search)
  const from = params.get("from")

  const { data, setData, post, processing, errors } = useForm<{
    business: BusinessFormData
  }>({
    business: {
      business_name: "",
      business_type: "store",
      description: "",
      phone: "",
      email: "",
      website: "",
      address: "",
      latitude: "",
      longitude: "",
      neighborhood_id: neighborhoods?.[0] ? String(neighborhoods[0].id) : "",
      opening_hours: "",
      delivery_coverage: "",
      images: [],
      image_urls: [],
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    // Inertia useForm will serialize to FormData when forceFormData is true and include CSRF automatically
    post(businessesCreatePath(), { forceFormData: true })
  }

  const handleCancel = () => {
    if (from) {
      router.visit(from)
    } else {
      router.visit(marketplacePath())
    }
  }

  return (
    <AppLayout>
      <Head title="Crear negocio" />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <BusinessForm
          title="Crear negocio"
          data={data.business}
          errors={errors as unknown as Record<string, string>}
          neighborhoods={neighborhoods}
          processing={processing}
          onChange={(partial) =>
            setData("business", { ...data.business, ...partial })
          }
          onSubmit={submit}
          onCancel={handleCancel}
          submitLabel="Guardar"
        />
      </div>
    </AppLayout>
  )
}
